export const appTitle = 'Cinephile';
export const appStorageName = 'cinephile-app-favs';
export const API_KEY = 'a8e92a2090af326502da77a3e46a6bc7';
export const API_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhOGU5MmEyMDkwYWYzMjY1MDJkYTc3YTNlNDZhNmJjNyIsInN1YiI6IjYxNDhmYjQ3OWYwZTE5MDA2NDgxOWEwMSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.pebdrC2fSZqa0aBJBbjBT27ihDlP5LfhWQ7hTC86Vj4';
export const APP_FOLDER_NAME = 'cinephile';